import styled from 'styled-components';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const Wrapper = styled.div`
  padding: 16px;
`;

export const SaveButton = styled(Button)`
  width: 200px;
`;

export const DropdownContainer = styled(Flex).attrs({ direction: 'column' })`
  height: 30vh;
  overflow: auto;
`;
